
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"6.063","height":"6.061"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 25860","d":"M3.031 3.03l-2.5 2.5 2.5-2.5-2.5-2.5 2.5 2.5 2.5-2.5-2.5 2.5 2.5 2.5-1.25-1.25z","fill":"rgba(0,0,0,0)","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    